import { mapActions, mapGetters, mapMutations } from "vuex";
import IconIdCard from "@/components/@icons/IconIdCard.vue";
import IconUser from "@/components/@icons/IconUser.vue";
import IconMenu from "@/components/@icons/IconMenu.vue";
import IconEducation from "@/components/@icons/IconEducation.vue";
import IconHistory from "@/components/@icons/IconHistory.vue";
import IconClub from "@/components/@icons/IconClub.vue";
import IconHeart from "@/components/@icons/IconHeart.vue";
import IconOrdersList from "@/components/@icons/IconOrdersList.vue";
import IconStorage from "@/components/@icons/IconStorage.vue";
import IconLogout from "@/components/@icons/IconLogout.vue";
import IconValentine from "@/components/@icons/IconValentine.vue";
import login from "@/components/popups/login";

export default {
  name: "nav-bar",
  components: {
    IconValentine,
    IconIdCard,
    IconUser,
    IconMenu,
    IconEducation,
    IconHistory,
    IconClub,
    IconHeart,
    IconOrdersList,
    IconStorage,
    IconLogout,
  },
  computed: {
    ...mapGetters({
      user: "profile/user",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      isManager: "profile/isManager",
      webinarList: "cosmobase/webinarList",
    }),
    isWithinValentinesDayRange() {
      const now = new Date();
      const startDate = new Date(2026, 1, 9, 9, 0, 0);
      const endDate = new Date(2026, 1, 14, 23, 59, 59);
      return now >= startDate && now <= endDate;
    },
  },
  async created() {
    await Promise.all([this.getWebinars()]);
  },
  methods: {
    ...mapActions({
      getWebinars: "cosmobase/GET_WEBINARS",
      logout: "auth/LOGOUT",
    }),
    ...mapMutations({
      changeValentineModal: "popups/CHANGE_VALENTINE_MODAL",
    }),
  },
};
